import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { layout, palette, typography } from '../styles';
import { fromThemeColors } from '../Theme';
export var StyledCounterBadge = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tborder-radius: 12px;\n\tcolor: ", ";\n\tdisplay: inline-block;\n\tfont-weight: ", ";\n\tpadding: 0 ", ";\n\theight: ", ";\n\tline-height: ", ";\n\tfont-size: ", ";\n"])), function (props) {
  return props.isEmpty ? palette.grey300 : fromThemeColors('primary');
}, function (props) {
  return props.isEmpty ? palette.grey900 : palette.white;
}, typography.weights.medium, layout.smallSpace, layout.mediumLargeSpace, layout.mediumLargeSpace, typography.sizes.sml);
export var StyledRedCounterBadge = styled(StyledCounterBadge)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n"])), function (props) {
  return props.isEmpty ? palette.grey300 : palette.red900;
});